import moment from 'moment';

export const formatDate = (date) => {
  const format = 'DD-MMM, YYYY'
  return moment(date).format(format);
};
export const formatDateTime = (date) => {
  const format = 'DD-MMM, YYYY HH:MM:SS'
  return moment(date).format(format);
};


export const cleanObject = (obj) => {
  if (Array.isArray(obj)) {
    return obj.filter(v => v !== "" && v !== null && v !== undefined);
  }

  if (typeof obj === "object" && obj !== null) {
    const newObj = {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      // recursive clean
      const cleanedValue = cleanObject(value);

      const isEmptyObject =
        typeof cleanedValue === "object" &&
        !Array.isArray(cleanedValue) &&
        Object.keys(cleanedValue).length === 0;

      const isEmptyArray =
        Array.isArray(cleanedValue) && cleanedValue.length === 0;

      if (
        cleanedValue !== "" &&
        cleanedValue !== null &&
        cleanedValue !== undefined &&
        !isEmptyObject &&
        !isEmptyArray
      ) {
        newObj[key] = cleanedValue;
      }
    });

    return newObj;
  }

  return obj;
};